import { render } from "./AccountBar.vue?vue&type=template&id=68f8af9d&scoped=true&ts=true"
import script from "./AccountBar.vue?vue&type=script&lang=ts"
export * from "./AccountBar.vue?vue&type=script&lang=ts"

import "./AccountBar.vue?vue&type=style&index=0&id=68f8af9d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68f8af9d"]])

export default __exports__